/**
 * BulkResyncRunningState — spinner shown while the resync is in progress.
 */
import React from 'react';
import { RotateCw } from 'lucide-react';
import { useT } from '../../i18n/I18nContext.jsx';

export function BulkResyncRunningState() {
  const t = useT();
  return (
    <div style={{ padding: 28, textAlign: 'center' }}>
      <RotateCw size={22} color="#f59e0b" className="spin" />
      <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-primary)', marginTop: 10 }}>
        {t('erp.bulkResync.orchestrating', 'Orchestrating bulk re-sync…')}
      </div>
      <div style={{ fontSize: 10, color: 'var(--text-muted)', marginTop: 4 }}>
        {t('erp.bulkResync.pushingTiers', 'Pushing tiers → iterating clients')}
      </div>
    </div>
  );
}
